export interface OrnamentStyle {
  name: string
  caption: string
  image: string
}

export const ornamentStyles: OrnamentStyle[] = [
  {
    name: 'Esferas con recuerdos',
    caption: 'Fotos que se convierten en decoración',
    image:
      'https://cdn.magicpatterns.com/uploads/ntbLEBrwnwNabeVZhsGTj5/esferas_con_recuerdos.jpg',
  },
  {
    name: 'Esferas florales',
    caption: 'Flores secas y follaje delicado',
    image:
      'https://cdn.magicpatterns.com/uploads/iv9zE3tYhPDGHUdZgH1MZp/esferas_flores.jpg',
  },
  {
    name: 'Esferas pintadas',
    caption: 'Paisajes y diseños con acrílicos',
    image:
      'https://cdn.magicpatterns.com/uploads/nVpS7rzHd66NaLbRzGQyuw/esferas_pintadas_con_acrilicos.jpg',
  },
  {
    name: 'Esferas con personajes',
    caption: 'Papá Noel, muñecos y escenas navideñas',
    image:
      'https://cdn.magicpatterns.com/uploads/gr7svq428gPgyKNd7LkvWe/esferas_personajes.jpg',
  },
  {
    name: 'Esferas con nombres',
    caption: 'Personalizadas una por una',
    image:
      'https://cdn.magicpatterns.com/uploads/oDUhUP2h71tTvS3Uv2QLYG/esferas_nombres.jpg',
  },
  {
    name: 'Esferas con efecto nieve',
    caption: 'Escenas invernales dentro del cristal',
    image:
      'https://cdn.magicpatterns.com/uploads/oPGDgXpu4C2hWaE1mWjbPk/esferas_efecto_nieve.jpg',
  },
  {
    name: 'Esferas infantiles',
    caption: 'Ideales para crear en familia',
    image:
      'https://cdn.magicpatterns.com/uploads/4NP9sQCiKmaDZefrZG9HMv/esferas_infantiles.jpg',
  },
  {
    name: 'Esferas premium',
    caption: 'Acabados elegantes en crema y dorado',
    image:
      'https://cdn.magicpatterns.com/uploads/wZYbE3cY87ricuYDxksCzT/esferas_premium.jpg',
  },
]

export interface GalleryPhoto {
  alt: string
  image: string
}

/** Imágenes usadas en los carruseles automáticos (hero y previo a testimonios). */
export const galleryCarousel: GalleryPhoto[] = [
  {
    alt: 'Manos pintando a mano esferas navideñas sobre una mesa de trabajo',
    image: 'https://cdn.magicpatterns.com/uploads/dwUBXwT6Z2mu3NT8MTVMjD/image.png',
  },
  {
    alt: 'Esferas transparentes con letras doradas y perlas blancas',
    image: 'https://cdn.magicpatterns.com/uploads/frnRLi8RvL8m6JxrsHb8cu/image.png',
  },
  {
    alt: 'Esferas con fotos de recuerdo y copos de nieve',
    image: 'https://cdn.magicpatterns.com/uploads/ee3ehLd4gzGHS1TR99qXh1/image.png',
  },
  {
    alt: 'Esferas infantiles con fotos, gorritos navideños y pompones',
    image: 'https://cdn.magicpatterns.com/uploads/ohBsH9dxUPaadjk6zhgitS/image.png',
  },
  {
    alt: 'Esfera transparente con muñeco de nieve, regalo y estrellas doradas',
    image: 'https://cdn.magicpatterns.com/uploads/wKnE8XJe8Ca8y1Qrh7yjBn/image.png',
  },
  {
    alt: 'Esferas de cristal pintadas a mano con flores y follaje',
    image: 'https://cdn.magicpatterns.com/uploads/na5sv19fUFRUqJuFaGCnox/image.png',
  },
  {
    alt: 'Colección de esferas transparentes pintadas con hojas y moños',
    image: 'https://cdn.magicpatterns.com/uploads/sEe82Ayogx8duCziiQeQ53/image.png',
  },
  {
    alt: 'Esferas mate en rojo y crema con renos, pinos y copos de nieve',
    image: 'https://cdn.magicpatterns.com/uploads/29d5k54HpieRtGTLkRdyFb/image.png',
  },
  {
    alt: 'Esferas transparentes con rodajas de naranja deshidratada y canela',
    image: 'https://cdn.magicpatterns.com/uploads/1Do7hfj5RZDfucoeFxeUuu/image.png',
  },
  {
    alt: 'Esferas decoradas como Papá Noel en fieltro',
    image: 'https://cdn.magicpatterns.com/uploads/mfuLS37evPwY41EPgjAQJP/image.png',
  },
  {
    alt: 'Coronas de pompones con moños de terciopelo colgando del árbol',
    image: 'https://cdn.magicpatterns.com/uploads/uFu3pgkMktne53pyYGz2bk/image.png',
  },
  {
    alt: 'Esfera de cristal con escena nevada, pinos y muñecos de nieve',
    image: 'https://cdn.magicpatterns.com/uploads/8zhAkxWrMorxeJdPZ9Wey6/image.png',
  },
  {
    alt: 'Esferas transparentes con Papá Noel y pinos dentro de la nieve',
    image: 'https://cdn.magicpatterns.com/uploads/wkqu8vWF4F2aiV9V5e1y1q/image.png',
  },
]
